import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  sideBar: {
    active: 'yellow',
    hoverBackground: '#4f61c5'
  }
})

export {
  theme
}
